import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-block',
    '& .MuiButtonBase-root': {
      margin: theme.spacing(0, 0, 0, -0.5),
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
    '& .MuiBreadcrumbs-separator': {
      margin: 0,
    },
  },
  current: {
    color: theme.palette.grey[200],
  },
}))

export default useStyles
